import {Provider} from '@clayui/core';
import ReactDOM from 'react-dom';
import App from './App';
import {TranslationProvider} from './context/TranslationContext';
import {getSpritemap} from './util/SpritemapUtil';

class MarketplacesWebComponent extends HTMLElement {
    private container?: HTMLDivElement;

    connectedCallback() {
        this.container = document.createElement('div');
        this.appendChild(this.container);
        ReactDOM.render(
            <Provider spritemap={getSpritemap()}>
                <TranslationProvider>
                    <App />
                </TranslationProvider>
            </Provider>,
            this.container
        );
    }

    disconnectedCallback() {
        if (this.container) {
            ReactDOM.unmountComponentAtNode(this.container);
            this.container.remove();
            this.container = undefined;
        }
    }
}

const TAG = 'up2date-apx-marketplaces';
if (!customElements.get(TAG)) {
    customElements.define(TAG, MarketplacesWebComponent);
}
